// Déplacer le module de prévisualisation en haut quand la page est chargée
document.addEventListener('DOMContentLoaded', function() {
  // Attendre un court instant pour s'assurer que tout est chargé
  setTimeout(function() {
    // Trouver le module de prévisualisation (qui est déjà dans la page)
    const previewModule = document.getElementById('name-preview-module');
    
    // Si le module existe
    if (previewModule) {
      // Trouver l'élément où nous voulons placer le module
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const productInfo = document.querySelector('.product__info-wrapper, .product-single__meta');
      
      // Si on trouve l'élément cible, déplacer le module avant
      if (productForm) {
        productForm.parentNode.insertBefore(previewModule, productForm);
      } else if (productInfo) {
        productInfo.prepend(previewModule);
      }
    }
  }, 100); // Attendre 100ms
});